<template>
  <sparkline
    v-if="options"
    :id="id"
    :year="`${yLabel} ${year}`"
    :value="value"
    :options="options"
    :hide-text="hideText"
    :max="max"
    :color="color"
  />
</template>

<script setup>
import Sparkline from "@/components/sparklines/Sparkline.vue"
import colors from "@/colors"
import { computed, onMounted, ref } from "vue"

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Array, required: true },
  xKey: { type: String, default: "x" },
  yKey: { type: String, default: "y" },
  yLabel: { type: String, default: "" },
  max: { type: Number },
  hideText: { type: Boolean },
  color: { type: String, default: "indigo" },
})

const value = ref()
const year = ref()
const options = ref()
const color = computed(() => {
  switch (props.color) {
    case "green":
      return colors.green[500]
    default:
      return colors.indigo[600]
  }
})
const xValues = computed(() => props.data.map(item => parseInt(item[props.xKey])))

const max = computed(() => {
  return props.max || Math.max(...xValues.value)
})

onMounted(() => {
  const { data, xKey, yKey } = props
  const defaultValue = data[data.length - 1][xKey]
  const defaultYear = data[data.length - 1][yKey]
  const firstYear = data[0][yKey]
  value.value = defaultValue
  year.value = defaultYear

  const series = [{
    type: "areaspline",
    data: xValues.value,
    point: {
      events: {
        mouseOver() {
          value.value = this.y
          year.value = this.x + firstYear
        },
        mouseOut() {
          value.value = defaultValue
          year.value = defaultYear
        },
      },
    },
  }]

  options.value = {
    series,
  }
})
</script>
